import React from 'react';
import { View } from 'react-native';
import { CardView } from 'design-system';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import AnalyticsChartSwitcher from 'features/analytics/components/AnalyticsChartSwitcher';
const WalkthroughAnalyticsChartSettingsBtn = ({ onNext, itemPosition }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.analyticsChipContainer}>
        <View style={{ width: itemPosition?.x || 0 }}/>
        <CardView noMargin style={styles.iconCard}>
          <AnalyticsChartSwitcher onNext={onNext}/>
        </CardView>
      </View>);
};
export default WalkthroughAnalyticsChartSettingsBtn;
const styleSet = createStyleSheets((colors) => ({
    analyticsChipContainer: {
        padding: rem(12),
        flexDirection: 'row',
    },
    iconCard: {
        padding: rem(4),
        backgroundColor: colors.background.dark,
    },
}));
